$('.block-case-study-grid').each(function() {
    // Find out how many cards there are
    var cards = $(this).find('.block-case-study-card').length;
    // Add as a class name to change the grid display
    $(this).find('.grid').addClass('card-count-' + cards);
});